module.exports = __webpack_public_path__ + "img/vms.6534fb4f.png";